import React, { useState, useEffect } from "react";
import useStyles from "./styles/testimony";
import { withTranslation } from "../../i18n";
import { testimonyData, testimonyAvatarSrcSet } from "../../static/new-landing-page/new-landing-data";

const blueStar = require("../../static/blue_star.png");


const TestimonyMobile = ({ i18n, t }) => {
    const language = i18n.language
    const data = testimonyData[language] || testimonyData.en
    const classes = useStyles();
    const [currentSlide, setCurrentSlide] = useState(0);
    const [isAutoPlaying, setIsAutoPlaying] = useState(true);

    // Mobile: Loop carousel dengan reset ke 0
    useEffect(() => {
        if (!isAutoPlaying) return;

        const interval = setInterval(() => {
            setCurrentSlide((prev) => {
                const nextSlide = prev + 1;
                if (nextSlide >= data.length) {
                    return 0; // Reset ke index 0
                }
                return nextSlide;
            });
        }, 3000);

        return () => clearInterval(interval);
    }, [isAutoPlaying, data.length]);

    const handleDotClick = (index) => {
        setCurrentSlide(index);
        setIsAutoPlaying(false);

        // Resume auto play after 5 seconds
        setTimeout(() => setIsAutoPlaying(true), 5000);
    };

    const handleCardClick = () => {
        setIsAutoPlaying(false);

        // Resume auto play after 5 seconds
        setTimeout(() => setIsAutoPlaying(true), 5000);
    };

    return (
        <div className={classes.root}>
            <span>{t("see-what-our-users-are-saying")}</span>
            <div className={classes.carouselContainer}>
                <div className={classes.mobileLayout}>
                    <div className={classes.carouselWrapper}>
                        <div
                            className={classes.carouselTrack}
                            style={{
                                transform: `translateX(-${currentSlide * 100}%)`
                            }}
                        >
                            {data.map((testimony, index) => (
                                <div
                                    className={classes.carouselSlide}
                                    key={index}
                                    onClick={handleCardClick}
                                >
                                    <div className={classes.ctnTestimony}>
                                        <div className={classes.ctnStar}>
                                            {Array.from({ length: 5 }).map((_, starIndex) => (
                                                <img src={blueStar} alt="" key={starIndex} />
                                            ))}
                                        </div>
                                        <div className={classes.ctnText}>
                                            <span>"{testimony.text}"</span>
                                        </div>
                                        <div className={classes.ctnUser}>
                                            <div className={classes.ctnImage}>
                                                <img src={testimony.avatar} srcSet={testimonyAvatarSrcSet(testimony.avatar)} sizes="20px" alt={testimony.name} loading="lazy" />
                                            </div>
                                            <div className={classes.ctnName}>
                                                <span>{testimony.name}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Dot Navigation */}
                    <div className={classes.dotNavigation}>
                        {data.map((_, index) => (
                            <button
                                key={index}
                                className={`${classes.dot} ${currentSlide === index ? classes.activeDot : ''}`}
                                onClick={() => handleDotClick(index)}
                                aria-label={`Go to slide ${index + 1}`}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default withTranslation(["myfitsociety"])(TestimonyMobile);
